import { LandscapeModule } from '../objects/LandscapeModule';
import { ProductModule } from '../objects/ProductModule';
import { RoomWall } from '../objects/RoomWall';
import { ProjectRenderer } from '../ProjectRenderer';
import { RendererMode } from '../types';
import { Mouse } from '../input/Mouse';

export class CursorHandler {
	constructor(private renderer: ProjectRenderer, private mouse: Mouse) {}

	setCursorType() {
		const hoveredObject = this.mouse.hoveredObject,
			draggedObject = this.mouse.mouseDragHandler.draggedObject;

		switch (this.renderer.mode) {
			case RendererMode.MEASURING:
				document.body.style.cursor = 'pointer';
				return;
			case RendererMode.COLORING:
				document.body.style.cursor = hoveredObject ? 'crosshair' : 'default';
				return;
			case RendererMode.MODULES:
			case RendererMode.ROOM:
				if (
					!hoveredObject &&
					!this.mouse.isRoomHovered &&
					!this.mouse.isRoomDragging
				) {
					document.body.style.cursor = 'default';
					return;
				}

				if (draggedObject || this.mouse.isRoomDragging) {
					document.body.style.cursor = 'grabbing';
					return;
				}

				if (this.mouse.isRoomHovered) {
					document.body.style.cursor = 'grab';
					return;
				}

				if (hoveredObject instanceof RoomWall) {
					document.body.style.cursor = 'grab';
					return;
				}

				if (hoveredObject instanceof LandscapeModule) {
					document.body.style.cursor = 'grab';
					return;
				}

				if (hoveredObject instanceof ProductModule) {
					document.body.style.cursor = 'grab';
					return;
				}
				break;

			default:
				break;
		}
	}
}
